export enum ExportReportTemplateSelectorArea {
  USA = 'USA',
  Canada = 'CAN',
  Mexico = 'MEX',
}

export const EXPORT_REPORT_AVAILABLE_AREAS = [
  ExportReportTemplateSelectorArea.USA,
  ExportReportTemplateSelectorArea.Canada,
  ExportReportTemplateSelectorArea.Mexico,
];
